<template>
  <div>
    <Header />

    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i> Bildirim Ekranı</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#"></a></li>
        </ul>
      </div>
      <div class="row">
        <div class="col-md-12 -webkit-scrollbar">
          <div class="hr-title-home hr-long center">
            <abbr><h2>Duyurular</h2></abbr>
          </div>
          <div class="tileHomepage" style="height: 500px; overflow-y: overlay">
            <div class="col-sm-12 sidenav">
              <button
                type="button"
                @click="routeAddNotices()"
                class="btn btn-outline-danger"
                style="float: right"
              >
                Genel Duyuru Ekle
              </button>
              <br />
              <br />
              <br />
              <div
                v-for="(item, index) in result"
                :key="index"
                class="col-md-12 col-lg-12 hower"
                style="margin-bottom: 10px"
              >
                <br />
                <a
                  @click="routeDetailNotices(item.id)"
                  style="font-size: 14px"
                  class="readmore"
                >
                  <div class="block-blog text-left">
                    <div class="content-blog">
                      <a
                        style="font-size: 14px"
                        class="readmore"
                        v-html="'<div>' + item.title + '</div>'"
                      ></a>
                      <p
                        style="
                        overflow: hidden;
                       display: -webkit-box;
                      -webkit-line-clamp: 1;
                      -webkit-box-orient: vertical;
                    "
                        v-html="'<div>' + item.content + '</div>'"
                      ></p>

                      <p>{{ item.reg_date }}</p>
                      <hr />
                    </div>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";

export default {
  data() {
    return {
      result: [],
      result2: [],
      situation: false,
      img_base_url: store.state.img_base_url,
    };
  },
  methods: {
    reload: function() {
      location.reload();
    },
    routeDetailNotices: function(itemId) {
      window.location.href = "#/noticesDetail?id=" + itemId;
    },
    routeAddNotices: function() {
      window.location.href = "#/addNotice";
    },
  },

  mounted: function() {
    let datas = [];
    let url = store.state.base_url + "User/getAllNotices.php?key=123";
    var sendData = {
      sectionsId: localStorage.getItem("sectionsId"),
    };

    axios
      .post(url, JSON.stringify(sendData))
      .then((response) => {
        datas = response.data.data;
        this.result = datas;
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  components: {
    Header,
    Sidebar,
  },
};
</script>
<style scoped>
.hower:hover {
  background: #c1163b;

  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminNotices.vue